<!-- Zweck: Stellt die HTML-Struktur für app register component im Frontend bereit. -->
@if (regConfig) {
  <div class="registercontent" [class.mobile]="msvc.isMobile()|async">
    <div>
      <div class="registerlogobox">
        <img class="logo" src="{{domaincfg.logofilename}}"/>
      </div>
      @if (settings && state_done && state_ok) {
        <div class="registerbox registerboxinfo">
          <div class="bar">Registrierung erfolgreich!</div>
          <p>Diese wird nun von unseren Mitarbeitern bearbeitet. Sie werden benachrichtigt sobald Ihr Benutzerkonto
          freigeschalten wurde!</p>
          <div style="text-align: center">
            <button mat-flat-button routerLink="/login">
              Jetzt anmelden
            </button>
          </div>
        </div>
      }
      @if (settings && state_done && state_error) {
        <div class="registerbox registerboxinfo">
          <div class="bar">Registrierung fehlgeschlagen!</div>
          <p>Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut!</p>
          <div style="text-align: center">
            <button (click)="resetState()" mat-flat-button>
              Erneut versuchen
            </button>
          </div>
        </div>
      }
      @if (settings && !state_done) {
        <div class="registerbox">
          <div class="bar">Registrieren</div>
          <hr>
            <div>
              Sind Sie bereits Kunde?
              <div>
                <mat-radio-group (change)="validate()" [(ngModel)]="req.is_customer">
                  <mat-radio-button [value]="false" style="margin-right: 5px">Neukunde</mat-radio-button>
                  <mat-radio-button [value]="true">Bereits Kunde</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            @if (regConfig && regConfig.text != '') {
              <div style="text-align: center">
                <hr>
                  <div [innerHTML]="regConfig.text|nl2br"></div>
                  @if (regConfig.required) {
                    <mat-checkbox [(ngModel)]="info_ok" required (change)="validate()">
                      Zur Kenntniss nehmen
                    </mat-checkbox>
                  }
                  <hr>
                  </div>
                }
                <hr>
                  <div>
                    <div class="formbox05">
                      <mat-form-field hintLabel="Max 40 Zeichen" appearance="outline">
                        <mat-label>Firmenname</mat-label>
                        <input #f_company_name (keyup)="validate()" [(ngModel)]="req.company_name" maxlength="40"
                          [errorStateMatcher]="error_company_name" matInput required>
                          @if (!error_company_name.loading && !error_company_name.isError && req.company_name) {
                            <span matSuffix>
                              <svg-icon matTooltip="OK" style="color: green">check</svg-icon>
                            </span>
                          }
                          @if (!error_company_name.loading && error_company_name.isError) {
                            <span matSuffix>
                              <svg-icon matTooltip="{{error_company_name.error_text}}" style="color: red">error</svg-icon>
                            </span>
                          }
                          @if (error_company_name.error_text) {
                            <mat-error>
                              <svg-icon>error</svg-icon>
                              {{error_company_name.error_text}}
                            </mat-error>
                          }
                          <mat-hint align="end">{{f_company_name.value?.length || 0}}/40</mat-hint>
                        </mat-form-field>
                      </div>
                      <div class="formbox05">
                        <mat-form-field appearance="outline">
                          <mat-label>UID Nummer</mat-label>
                          <input #f_company_uid (keyup)="validate()" [(ngModel)]="req.company_uid"
                            [errorStateMatcher]="error_company_uid" matInput required maxlength="14">
                            @if (!error_company_uid.loading && !error_company_uid.isError && req.company_uid) {
                              <span matSuffix>
                                <svg-icon matTooltip="OK" style="color: green">check</svg-icon>
                              </span>
                            }
                            @if (!error_company_uid.loading && error_company_uid.isError) {
                              <span matSuffix>
                                <svg-icon matTooltip="{{error_company_uid.error_text}}" style="color: red">error</svg-icon>
                              </span>
                            }
                            @if (error_company_uid.error_text) {
                              <mat-error>
                                <svg-icon>error</svg-icon>
                                {{error_company_uid.error_text}}
                              </mat-error>
                            }
                            <mat-hint align="end">{{f_company_uid.value?.length || 0}}/14</mat-hint>
                          </mat-form-field>
                        </div>
                        <hr>
                          <div class="formbox05">
                            <mat-form-field appearance="outline">
                              <mat-label>Vorname</mat-label>
                              <input #f_firstname (keyup)="validate()" [(ngModel)]="req.firstname" [errorStateMatcher]="error_firstname"
                                matInput required maxlength="40">
                                @if (!error_firstname.loading && !error_firstname.isError && req.firstname) {
                                  <span matSuffix>
                                    <svg-icon matTooltip="OK" style="color: green">success</svg-icon>
                                  </span>
                                }
                                @if (!error_firstname.loading && error_firstname.isError) {
                                  <span matSuffix>
                                    <svg-icon matTooltip="{{error_firstname.error_text}}" style="color: red">error</svg-icon>
                                  </span>
                                }
                                @if (error_firstname.error_text) {
                                  <mat-error>
                                    <svg-icon>error</svg-icon>
                                    {{error_firstname.error_text}}
                                  </mat-error>
                                }
                                <mat-hint align="end">{{f_firstname.value?.length || 0}}/40</mat-hint>
                              </mat-form-field>
                            </div>
                            <div class="formbox05">
                              <mat-form-field appearance="outline">
                                <mat-label>Nachname</mat-label>
                                <input #f_lastname (keyup)="validate()" [(ngModel)]="req.lastname" [errorStateMatcher]="error_lastname"
                                  matInput required maxlength="40">
                                  @if (!error_lastname.loading && !error_lastname.isError && req.lastname) {
                                    <span matSuffix>
                                      <svg-icon matTooltip="OK" style="color: green">success</svg-icon>
                                    </span>
                                  }
                                  @if (!error_lastname.loading && error_lastname.isError) {
                                    <span matSuffix>
                                      <svg-icon matTooltip="{{error_lastname.error_text}}" style="color: red">error</svg-icon>
                                    </span>
                                  }
                                  @if (error_lastname.error_text) {
                                    <mat-error>
                                      <svg-icon>error</svg-icon>
                                      {{error_lastname.error_text}}
                                    </mat-error>
                                  }
                                  <mat-hint align="end">{{f_lastname.value?.length || 0}}/40</mat-hint>
                                </mat-form-field>
                              </div>
                              <hr>
                                <div class="formbox05">
                                  <mat-form-field appearance="outline">
                                    <mat-label>Straße</mat-label>
                                    <input #f_street (keyup)="validate()" [(ngModel)]="req.street" [errorStateMatcher]="error_street" matInput
                                      required maxlength="60">
                                      @if (!error_street.loading && !error_street.isError && req.street) {
                                        <span matSuffix>
                                          <svg-icon matTooltip="OK" style="color: green">success</svg-icon>
                                        </span>
                                      }
                                      @if (!error_street.loading && error_street.isError) {
                                        <span matSuffix>
                                          <svg-icon matTooltip="{{error_street.error_text}}" style="color: red">error</svg-icon>
                                        </span>
                                      }
                                      @if (error_street.error_text) {
                                        <mat-error>
                                          <svg-icon>error</svg-icon>
                                          {{error_street.error_text}}
                                        </mat-error>
                                      }
                                      <mat-hint align="end">{{f_street.value?.length || 0}}/60</mat-hint>
                                    </mat-form-field>
                                  </div>
                                  <div class="formbox05">
                                    <mat-form-field appearance="outline">
                                      <mat-label>Hausnummer</mat-label>
                                      <input #f_housenr (keyup)="validate()" [(ngModel)]="req.housenr" [errorStateMatcher]="error_housenr"
                                        matInput required maxlength="20">
                                        @if (!error_housenr.loading && !error_housenr.isError && req.housenr) {
                                          <span matSuffix>
                                            <svg-icon matTooltip="OK" style="color: green">success</svg-icon>
                                          </span>
                                        }
                                        @if (!error_housenr.loading && error_housenr.isError) {
                                          <span matSuffix>
                                            <svg-icon matTooltip="{{error_housenr.error_text}}" style="color: red">error</svg-icon>
                                          </span>
                                        }
                                        @if (error_housenr.error_text) {
                                          <mat-error>
                                            <svg-icon>error</svg-icon>
                                            {{error_housenr.error_text}}
                                          </mat-error>
                                        }
                                        <mat-hint align="end">{{f_housenr.value?.length || 0}}/20</mat-hint>
                                      </mat-form-field>
                                    </div>
                                    <hr>
                                      <div class="formbox033">
                                        <mat-form-field appearance="outline">
                                          <mat-label>Land</mat-label>
                                          <mat-select #f_country (selectionChange)="validate()" [(value)]="req.country"
                                            [errorStateMatcher]="error_country"
                                            required>
                                            @for (c of settings.countries; track c) {
                                              <mat-option [value]="c.code">{{c.label}}</mat-option>
                                            }
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                      <div class="formbox033">
                                        <mat-form-field appearance="outline">
                                          <mat-label>PLZ</mat-label>
                                          <input #f_plz (keyup)="validate()" [(ngModel)]="req.plz" [errorStateMatcher]="error_plz" matInput
                                            required maxlength="10">
                                            @if (!error_plz.loading && !error_plz.isError && req.plz) {
                                              <span matSuffix>
                                                <svg-icon matTooltip="OK" style="color: green">success</svg-icon>
                                              </span>
                                            }
                                            @if (!error_plz.loading && error_plz.isError) {
                                              <span matSuffix>
                                                <svg-icon matTooltip="{{error_plz.error_text}}" style="color: red">error</svg-icon>
                                              </span>
                                            }
                                            @if (error_plz.error_text) {
                                              <mat-error>
                                                <svg-icon>error</svg-icon>
                                                {{error_plz.error_text}}
                                              </mat-error>
                                            }
                                            <mat-hint align="end">{{f_plz.value?.length || 0}}/10</mat-hint>
                                          </mat-form-field>
                                        </div>
                                        <div class="formbox033">
                                          <mat-form-field appearance="outline">
                                            <mat-label>Ort</mat-label>
                                            <input #f_city (keyup)="validate()" [(ngModel)]="req.city" [errorStateMatcher]="error_city" matInput
                                              required maxlength="50">
                                              @if (!error_city.loading && !error_city.isError && req.city) {
                                                <span matSuffix>
                                                  <svg-icon matTooltip="OK" style="color: green">success</svg-icon>
                                                </span>
                                              }
                                              @if (!error_city.loading && error_city.isError) {
                                                <span matSuffix>
                                                  <svg-icon matTooltip="{{error_city.error_text}}" style="color: red">error</svg-icon>
                                                </span>
                                              }
                                              @if (error_city.error_text) {
                                                <mat-error>
                                                  <svg-icon>error</svg-icon>
                                                  {{error_city.error_text}}
                                                </mat-error>
                                              }
                                              <mat-hint align="end">{{f_city.value?.length || 0}}/50</mat-hint>
                                            </mat-form-field>
                                          </div>
                                          <hr>
                                            <div>
                                              <div class="formbox05">
                                                <mat-form-field appearance="outline">
                                                  <mat-label>Telefonnummer</mat-label>
                                                  <input #f_telnr (keyup)="validate()" [(ngModel)]="req.telnr" [errorStateMatcher]="error_telnr"
                                                    matInput required maxlength="30">
                                                    <mat-hint>
                                                      Bitte mit Ländervorwahl angeben (+43, +49, ...).
                                                    </mat-hint>
                                                    @if (!error_telnr.loading && !error_telnr.isError && req.telnr) {
                                                      <span matSuffix>
                                                        <svg-icon matTooltip="OK" style="color: green">success</svg-icon>
                                                      </span>
                                                    }
                                                    @if (!error_telnr.loading && error_telnr.isError) {
                                                      <span matSuffix>
                                                        <svg-icon matTooltip="{{error_telnr.error_text}}" style="color: red">error</svg-icon>
                                                      </span>
                                                    }
                                                    @if (error_telnr.error_text) {
                                                      <mat-error>
                                                        <svg-icon>error</svg-icon>
                                                        {{error_telnr.error_text}}
                                                      </mat-error>
                                                    }
                                                    <mat-hint align="end">{{f_telnr.value?.length || 0}}/30</mat-hint>
                                                  </mat-form-field>
                                                </div>
                                              </div>
                                              <hr>
                                                <div class="formbox05">
                                                  <mat-form-field appearance="outline">
                                                    <mat-label>E-Mail Adresse</mat-label>
                                                    <input #f_mail (keyup)="validate()" [(ngModel)]="req.mail" [errorStateMatcher]="error_mail" matInput
                                                      required maxlength="100">
                                                      <mat-hint>
                                                        Ihre E-Mail Adresse dient zugleich als Benutzername!
                                                      </mat-hint>
                                                      @if (error_mail.loading) {
                                                        <span matSuffix>
                                                          <div style="white-space: nowrap">
                                                            <mat-spinner [diameter]="15"></mat-spinner> Prüfe..
                                                          </div>
                                                        </span>
                                                      }
                                                      @if (!error_mail.loading && !error_mail.isError && req.mail != '') {
                                                        <span matSuffix>
                                                          <svg-icon matTooltip="OK" style="color: green">success</svg-icon>
                                                        </span>
                                                      }
                                                      @if (!error_mail.loading && error_mail.isError) {
                                                        <span matSuffix>
                                                          <svg-icon matTooltip="{{error_mail.error_text}}" style="color: red">error</svg-icon>
                                                        </span>
                                                      }
                                                      @if (error_mail.error_text) {
                                                        <mat-error>
                                                          <svg-icon>error</svg-icon>
                                                          {{error_mail.error_text}}
                                                        </mat-error>
                                                      }
                                                      <mat-hint align="end">{{f_mail.value?.length || 0}}/100</mat-hint>
                                                    </mat-form-field>
                                                  </div>
                                                  <div class="formbox05">
                                                    <mat-form-field appearance="outline">
                                                      <mat-label>Passwort</mat-label>
                                                      <input #f_password (keyup)="validate()" [(ngModel)]="req.password" [errorStateMatcher]="error_password"
                                                        matInput
                                                        required type="password">
                                                        <mat-hint>
                                                          Mindestanforderungen für Ihr Passwort: 8 Zeichen.
                                                          Empfohlen: 8-10 Zeichen + Sonderzeichen + Groß-/Kleinschreibung.
                                                        </mat-hint>
                                                        @if (!error_password.loading && !error_password.isError && req.password) {
                                                          <span matSuffix>
                                                            <svg-icon matTooltip="OK" style="color: green">success</svg-icon>
                                                          </span>
                                                        }
                                                        @if (!error_password.loading && error_password.isError) {
                                                          <span matSuffix>
                                                            <svg-icon matTooltip="{{error_password.error_text}}" style="color: red">error</svg-icon>
                                                          </span>
                                                        }
                                                        @if (error_password.error_text) {
                                                          <mat-error>
                                                            <svg-icon>error</svg-icon>
                                                            {{error_password.error_text}}
                                                          </mat-error>
                                                        }
                                                      </mat-form-field>
                                                    </div>
                                                    @if (settings.interests.length > 0) {
                                                      <hr>
                                                      }
                                                      @if (settings.interests.length > 0) {
                                                        <div>
                                                          Interessiert an
                                                          <div>
                                                            @for (i of settings.interests; track i) {
                                                              <mat-checkbox [(ngModel)]="interest_list[i]"
                                                              style="margin: 5px">{{i}}</mat-checkbox>
                                                            }
                                                          </div>
                                                        </div>
                                                      }
                                                      <hr>
                                                        <div>
                                                          <mat-checkbox (change)="validate()" [(ngModel)]="req.agb">AGB's gelesen und akzeptiert</mat-checkbox>
                                                          | <a target="_blank" routerLink="/docs/agbs">Lesen</a>
                                                        </div>
                                                        <div>
                                                          <mat-checkbox (change)="validate()" [(ngModel)]="req.dsgvo">Datenschutzbestimmungen gelesen und akzeptiert
                                                          </mat-checkbox>
                                                          | <a target="_blank" routerLink="/docs/datenschutz">Lesen</a>
                                                        </div>
                                                        <hr>
                                                          <div>
                                                            <button (click)="send()" [disabled]="!valid" mat-flat-button style="width: 100%">
                                                              Registrierung absenden
                                                            </button>
                                                          </div>
                                                          <div style="text-align: center; margin-top: 10px;">
                                                            <button mat-raised-button routerLink="/login">
                                                              <svg-icon>abbrechen</svg-icon>
                                                              Abbrechen
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    }
                                                  </div>
                                                </div>
                                              }
